<!-- Screenname:Unit Master Creation
Developer Name: Antony.
Created date on:1/02/2023 -->
<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? t('assetManagement.DepreciationMethodMaster.edittitle')
        : t('assetManagement.DepreciationMethodMaster.title')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              v-model="isForm.Code"
              type="text"
              :label="t('assetManagement.DepreciationMethodMaster.code')"
              clearable
              disabled
              :id="t('assetManagement.DepreciationMethodMaster.code')"
              :name="t('assetManagement.DepreciationMethodMaster.code')"
              :rules="{ required: true }"
              :required-icon="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="isForm.MethodName"
              type="text"
              :label="t('assetManagement.DepreciationMethodMaster.Name')"
              clearable
              :id="t('assetManagement.DepreciationMethodMaster.MethodName')"
              :name="t('assetManagement.DepreciationMethodMaster.MethodName')"
              :rules="{ required: true }"
              :required-icon="true"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="isForm.Description"
              type="text"
              :label="t('assetManagement.DepreciationMethodMaster.description')"
              clearable
              :id="t('assetManagement.DepreciationMethodMaster.Description')"
              :name="t('assetManagement.DepreciationMethodMaster.Description')"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="isForm.Formula"
              type="text"
              :label="t('assetManagement.DepreciationMethodMaster.formula')"
              clearable
              :id="t('assetManagement.DepreciationMethodMaster.Formula')"
              :name="t('assetManagement.DepreciationMethodMaster.Formula')"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="isForm.DepreciationRate"
              type="text"
              :label="
                t('assetManagement.DepreciationMethodMaster.depreciationRate')
              "
              clearable
              :id="
                t('assetManagement.DepreciationMethodMaster.depreciationRate')
              "
              :name="
                t('assetManagement.DepreciationMethodMaster.depreciationRate')
              "
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="isForm.UsefulLife"
              type="text"
              :label="t('assetManagement.DepreciationMethodMaster.UsefulLife')"
              clearable
              :id="t('assetManagement.DepreciationMethodMaster.UsefulLife')"
              :name="t('assetManagement.DepreciationMethodMaster.UsefulLife')"
            />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import DepreciationMethodMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/DepreciationMethodMasterService";
import { useRoute } from "vue-router";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../../../../modules/Inventory/Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import { DepreciationMethodData } from "../../../../../../../modules/Inventory/pages/AssetManagement/Masters/model/depreciationMethodMasterModel";

import moment from "moment";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    CustomDropdown,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
  },
  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let isSubmitCalled = false;
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let options = ref({
      statusArray: [
        { name: "Active", value: 0 },
        { name: "InActive", value: 1 },
      ],
    });
    let commonVariable = ref({
      HospitalId: session.OrganizationId,
      BranchId: session.BranchId,
      UserId: session.UserId,
      EntityId: EntityData.EntityId,
    });

    let loading = ref(false);
    let Saveloading = ref(false);

    const isForm = ref<DepreciationMethodData>({
      IsNew: false,
      IsModified: false,
      IsDeleted: false,
      IsActive: true,
      CreatedAt: "2024-11-05T14:32:03.784Z",
      ModifiedAt: "2024-11-05T14:32:03.784Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: "2024-11-05T14:32:03.784Z",
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: false,
      LevelsOfApproval: 0,
      Id: 0,
      MethodName: "",
      Description: "",
      Formula: "",
      DepreciationRate: ref(),
      UsefulLife: ref(),
      Status: "",
      UpdatedAt: "2024-11-05T14:32:03.784Z",
      UpdatedBy: "",
      EstimatedCost: 0,
      Code: "",
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Clear Input Fields
    const copyisForm = JSON.parse(JSON.stringify(isForm.value));
    function IsClear() {
      Object.assign(isForm.value, copyisForm);
      isForm.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
      GetCode();
    }

    //Row Edit
    async function IsEdit() {
      debugger;
      emit("loadershow");
      try {
        label.value = "Update";
        const EditId = model.value.Id;
        const response = await DepreciationMethodMasterService.getfindonedata(
          EditId
        );
        const data = response["result"];
        console.log(response["result"]);

        Object.keys(isForm.value).forEach((key) => {
          if (data[key]) isForm.value[key] = data[key];
        });

        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    //Save
    const IsSubmit = async () => {
      debugger;
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let msg = "";
        isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.UpdatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.BranchId = commonVariable.value.BranchId;
        isForm.value.HospitalId = commonVariable.value.HospitalId;
        isForm.value.ModifiedBy = commonVariable.value.UserId;
        isForm.value.CreatedBy = commonVariable.value.UserId;
        isForm.value.EntityId = Number(commonVariable.value.EntityId);
        let objinsert = Object.assign(isForm.value);
        console.log(objinsert);
        if (isForm.value.Id != 0) {
          isForm.value.EntityOperationId = props.OperationID.UpdateId;
          const data_response =
            await DepreciationMethodMasterService.updatedata(isForm.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          isForm.value.EntityOperationId = props.OperationID.CreateId;
          const data_response =
            await DepreciationMethodMasterService.createdata(isForm.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        emit("loaderhide");
        Saveloading.value = false;
        alert(error);
      }
    };

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        EntityId: commonVariable.value.EntityId,
        HospitalId: commonVariable.value.HospitalId,
        BranchId: commonVariable.value.BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      isForm.value.Code = result;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      isForm.value.MethodName = "";
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    return {
      options,
      t,
      model,
      showModal: ref(false),
      isForm,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      GetCode,
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      loading,
      Saveloading,
    };
  },
});
</script>
